module.exports = __webpack_public_path__ + "band_10_daughter.3e102a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_10_daughter.png
// module id = vP8K
// module chunks = 0